import React from 'react'
import Router from 'next/router'
import { useRouter } from 'next/dist/client/router'

import {
  errorMainTitle, errorMessage,
  errorSubTitle,
  RequestError
} from '~/common/define/requestError'
import { Cookie, removeCookie } from '~/common/utils/cookie'
import { loginPath, routerSpacePath } from '~/common/define/path'
import { lineToBreak } from '~/common/utils/string'
import MainContent, { MainContentType } from '~/components/wrapper/section/MainContent'
import DescriptionText from '~/components/wrapper/text/DescriptionText'
import Segments from '~/components/wrapper/section/Segments'
import SupportButton from '~/components/atoms/button/SupportButton'
import AlertTitle from '~/components/atoms/title/AlertTitle'

interface Props {
  error: RequestError
}

const ErrorContent = ({error}: Props) => {
  const router = useRouter()

  const goLogin = () => {
    removeCookie(Cookie.ACCESS_TOKEN)
    Router.push(loginPath())
  }

  const mainTitle = errorMainTitle(error)
  const subTitle = errorSubTitle(error)
  const message = errorMessage(error)

  return (
    <MainContent type={MainContentType.ONLY}>
      <Segments column center>
        <AlertTitle
          mainText={mainTitle}
        />
        {subTitle &&
          <>
            <DescriptionText>{subTitle}</DescriptionText>
          </>
        }
        <DescriptionText>{lineToBreak(message)}</DescriptionText>
        {error == RequestError.UNAUTHORIZED ?
          <SupportButton onClick={() => goLogin()}>
            ログインへ
          </SupportButton>
          :
          <SupportButton link={routerSpacePath(router)}>
            TOPへ戻る
          </SupportButton>
        }
      </Segments>
    </MainContent>
  )
}

export default ErrorContent